/**
 * 查新任务创建数据
 */
export interface FtoReportTaskData {
    /**
     * 任务 id
     */
    taskId: string;
    /**
     * 文本内容
     */
    text: string;
    /**
     * 专利受理局
     */
    country: string[];
    /**
     * 附件 id 列表
     */
    attachmentIds?: string[];
    /**
     * 法律状态
     */
    legalStatus: number[];
    /**
     * 包含公司
     */
    includeCompany: string[];
    /**
     * 排除公司
     */
    excludeCompany: string[];
    /**
     * 申请日开始
     */
    apdStart?: string;
    /**
     * 申请日结束时间
     */
    apdEnd?: string;
}

/**
 * 查新任务创建服务
 */
export interface FtoReportTaskCreator {
    /**
     * 创建查新任务
     * @description 创建任务成功后，会更新检索结果报告模型 {@link FtoReportRetrievalResultReportModel} 的 techEssential 和 userInput 字段
     * @param data 创建查新任务数据
     * @returns
     */
    createTask(data: FtoReportTaskData): Promise<void>;
}

export const FtoReportTaskCreator = Symbol.for('FtoReportTaskCreator');
